export default "__VITE_ASSET__BRLSImEK__"